import { render, staticRenderFns } from "./ProductSpecialist.vue?vue&type=template&id=ffe2b1d2&scoped=true&"
import script from "./ProductSpecialist.vue?vue&type=script&lang=js&"
export * from "./ProductSpecialist.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecialist.vue?vue&type=style&index=0&id=ffe2b1d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe2b1d2",
  null
  
)

export default component.exports